import React from "react";
import { useAuth } from "../../Store/AuthContext";
import { AboutFetchData } from "../../APIS/FetchAPIs";

export default function AboutSectionHome() {
  const { RendomTokenfetch } = useAuth();
  const [aboutData] = AboutFetchData(RendomTokenfetch);
  return (
    <>
      <section className="about-us-section about-us-section-style3 section-padding">
        <div className="container">
          <div className="row section-title">
            <h2>{aboutData?.title || ""}</h2>
          </div>

          <div className="row content">
            <div className="col col-md-7">
              <div className="box">
                {aboutData?.about_tagline && (
                  <h3>{aboutData?.about_tagline || ""}</h3>
                )}
                <div
                  className=""
                  dangerouslySetInnerHTML={{
                    __html: aboutData.about_description,
                  }}
                ></div>
                {/* <div className="signature">
                  {aboutData.about_banner !== "" ? (
                    <img
                      src={aboutData.about_banner}
                      alt={aboutData.aboutbanner_alt}
                      title={aboutData.aboutbanner_title}
                      className="img img-responsive"
                    />
                  ) : (
                    ""
                  )}
                </div> */}
              </div>
            </div>

            <div className="col col-md-5 about-company-slider-wrapper">
              <div className="about-company-slider">
                <div>
                  {aboutData.about_image !== "" ? (
                    <img
                      src={aboutData.about_image}
                      alt={aboutData.aboutimg_alt}
                      title={aboutData.aboutimg_title}
                      className="img img-responsive"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
